// src/components/tiptap/PublicMessageEditor.js
import React from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Placeholder from "@tiptap/extension-placeholder";

export default function PublicMessageEditor({
  onChange,
  placeholder = "Write your message…",
}) {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: false,
      }),
      Link.configure({
        openOnClick: true,
      }),
      Placeholder.configure({
        placeholder,
      }),
    ],
    content: "",
    onUpdate: ({ editor }) => {
      const json = editor.getJSON();
      if (onChange) onChange(json);
    },
  });

  if (!editor) return null;

  const toggle = (cmd) => {
    cmd();
  };

  return (
    <div className="border rounded-md p-2 bg-white space-y-2">
      {/* Simple toolbar */}
      <div className="flex flex-wrap gap-2 text-xs border-b pb-2">
        <button
          type="button"
          onClick={() => toggle(() => editor.chain().focus().toggleBold().run())}
          className="px-2 py-1 border rounded"
        >
          B
        </button>
        <button
          type="button"
          onClick={() =>
            toggle(() => editor.chain().focus().toggleItalic().run())
          }
          className="px-2 py-1 border rounded"
        >
          I
        </button>
        <button
          type="button"
          onClick={() =>
            toggle(() => editor.chain().focus().toggleBulletList().run())
          }
          className="px-2 py-1 border rounded"
        >
          • List
        </button>
        <button
          type="button"
          onClick={() => {
            const url = window.prompt("Enter URL");
            if (!url) return;
            editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();
          }}
          className="px-2 py-1 border rounded"
        >
          Link
        </button>
      </div>

      <EditorContent editor={editor} />
    </div>
  );
}